// T14 — injectable RequestContext for the Claim Web Link feature.
//
// staffRequestContext() mirrors the existing localStorage-based
// authHeaders()/tenantHeaders() pattern (see useMediaAiEnrichment.ts) so
// staff callers keep their current bearer-token auth unchanged.
// portalRequestContext(token) is for the unauthenticated public portal —
// it sends only X-Share-Token; tenant/job scope is resolved server-side
// from the token, never trusted from a client header.

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';

export interface RequestContext {
  baseUrl: string;
  headers: Record<string, string>;
}

export function staffRequestContext(): RequestContext {
  const headers: Record<string, string> = {};
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('access_token') || localStorage.getItem('super_admin_token') || '';
    const tenantId = localStorage.getItem('tenant_id') || '';
    const userType = localStorage.getItem('user_type') || '';
    headers.Authorization = `Bearer ${token}`;
    headers['X-Tenant-Id'] = tenantId;
    headers['X-User-Type'] = userType;
  }

  return {
    baseUrl: `${API_URL}/api/v1/insurance/vehicle-claims`,
    headers,
  };
}

export function portalRequestContext(token: string): RequestContext {
  return {
    baseUrl: `${API_URL}/api/v1/insurance/vehicle-claims`,
    headers: {
      'X-Share-Token': token,
    },
  };
}
